import isEmpty from 'lodash/isEmpty';
import isBoolean from 'lodash/isBoolean';
import isArray from 'lodash/isArray';
import isNumber from 'lodash/isNumber';

const escape = (obj: any) => {
  const mutateObj = obj;
  Object.keys(mutateObj).forEach((key) => {
    if (
      (!isBoolean(mutateObj[key])
                && !isArray(mutateObj[key])
                && !isNumber(mutateObj[key])
                && mutateObj[key] !== null)
            && (!mutateObj[key] || isEmpty(mutateObj[key]))
    ) {
      delete mutateObj[key];
    }
  });
  return mutateObj;
};

export {
  escape as default,
  escape,
};
